// const inputField = document.querySelector('#url');

const img = document.querySelector("#img");
const form = document.querySelector(".search-bar");
const link = document.querySelector("#link");
const inputField = form.url;
const baseUrl = "https://www.instagram.com/p/";

function getMediaByUrl() {
  console.log(inputField.value);
  //validation
  let mediaId = null;
  let tmp = inputField.value.split("/");
  for (let i = 1; i < tmp.length; i++) {
    if (tmp[i].length > 0 && tmp[i].toLowerCase() == "p") {
      if (tmp[i + 1].length > 0) {
        mediaId = tmp[i + 1];
        break;
      }
    }
  }
  if (mediaId) {
    let src = baseUrl + mediaId + "/media/?size=l";
    console.log(src);

    img.onerror = e => {
      console.log(e);
      /*
      document.querySelector(".result-container").style.display = "none";
      alert("找不到照片.. 可能網址貼錯囉！");
      */
    };

    //version1: get real link
    fetch(src).then(res => {
      console.log(res);
      //get real link
      if (res.status && res.status == 200) {
        console.log("success");
        img.src = res.url;
        link.href = res.url;
      }
      //fallback
      else {
        console.log("fail");
        img.src = src;
        link.href = src;
      }
      document.querySelector(".result-container").style.display = "block";
    });
    /*
      //version2: direct assign (redirect)
      img.src = src;
      link.href = src;
      document.querySelector(".result-container").style.display = "block";
      */
  } else {
    console.log("GG");
    alert("網址貼錯囉！");
  }
}

function getAvatarByUrl() {
  //validation
  let mediaId = inputField.value;

  console.log("user=", mediaId);
  if (mediaId) {
    let src = `https://www.instagram.com/${mediaId}/?__a=1`;
    console.log(src);

    img.onerror = e => {
      console.log(e);
      /*
      document.querySelector(".result-container").style.display = "none";
      alert("找不到照片.. 可能網址貼錯囉！");
      */
    };

    fetch(src)
      .then(res => res.json())
      .then(data => {
        // console.log(data)
        let pic =
          data.graphql.user.profile_pic_url_hd ||
          data.graphql.user.profile_pic_url;
        console.log(pic);
        img.src = pic;
        link.href = pic;
        document.querySelector(".result-container").style.display = "block";
      })
      .catch(e =>{
        console.log(e)
        alert("無此帳號噢！")
      });
  } else {
    console.log("GG");
    alert("網址貼錯囉！");
  }
}

function getMediaBySource() {
  //let script = inputField;
  let results = [];
  let is_video = false;
  //console.log(inputField.value)
  const scripts = inputField.value.split("<script");
  console.log(scripts);
  const script = scripts.filter(item => {
    return item.includes("graphql");
  })[0];
  console.log(script);
  if (script === undefined) {
    alert("請貼原始碼呦！！");
    return;
  }
  let start = script.indexOf("{");
  let len = script.lastIndexOf(")") - start;
  //alert(script.substr(start,len);
  //alert(len);
  //completion(script.substr(start,len))
  json = JSON.parse(script.substr(start, len));
  //alert(JSON.stringify(json))
  //completion()

  const { shortcode_media } = json.graphql;

  //alert(shortcode_media)

  //check if video
  if (shortcode_media.is_video && shortcode_media.video_url) {
    is_video = true;
    results = [
      {
        src: shortcode_media.video_url
      }
    ];
  } else {
    //check if multiple
    const { edge_sidecar_to_children } = shortcode_media;
    if (
      edge_sidecar_to_children &&
      edge_sidecar_to_children.edges &&
      edge_sidecar_to_children.edges.length
    ) {
      let edges = edge_sidecar_to_children.edges;

      results = edges.map(
        item =>
          item.node.display_resources[item.node.display_resources.length - 1]
      );
    }
    //else, not multiple
    else {
      //assume last element is highest resolution

      results = [
        shortcode_media.display_resources[
          shortcode_media.display_resources.length - 1
        ]
      ];
    }
  }

  console.log("res=", results);
  if (is_video) {
    /*
    img.src = results[0].src;
    link.href = results[0].src;
    link.innerHTML = "下載影片";
*/
    document.querySelector(".result-container").innerHTML = `
    <div style='text-align:center'><video controls autoplay> <source src='${results[0].src}' type="video/mp4"></video></div>
    <div style='text-align:center'><a id="link" href="${results[0].src}" target="_blank">下載影片</a></div>
    `;
    document.querySelector(".result-container").style.display = "block";
  } else {
    //multi photos
    if (results.length > 1) {
      document.querySelector(".result-container").innerHTML = "";
      for (let i = 0; i < results.length; i++) {
        document.querySelector(
          ".result-container"
        ).innerHTML += `<div style='text-align:center'><a id="link" href="${
          results[i].src
        }" target="_blank">下載第${i + 1}張照片</a></div>`;
      }
      document.querySelector(".result-container").style.display = "block";
    } else {
      img.src = results[0].src;
      link.href = results[0].src;
      document.querySelector(".result-container").style.display = "block";
    }
  }
}

form.addEventListener("submit", e => {
  e.preventDefault();
  console.log(inputField.type);
  //'url'
  if (inputField.type == "url") {
    console.log("ver: media by url");
    getMediaByUrl();
  }
  //'text'
  else {
    if (location.pathname.includes("avatar")) {
      console.log("ver: avatar");
      getAvatarByUrl();
    } else {
      console.log("ver: media by source");
      getMediaBySource();
    }
  }
});
